import isNode from 'is-node';

import { RouterStore } from '@superwf/mobx-react-router';
import LanguageStore from '@stores/LanguageStore';
import RouteStore from '@stores/RouteStore';
import SsoStore from '@stores/SsoStore';
import TranslateStore from '@stores/TranslateStore';
import CookieConsentStore from '@stores/CookieConsentStore';
import DisturbanceMapStore from '@stores/DisturbanceMapStore';
import DisturbanceModalStore from '@stores/DisturbanceModalStore';
import ChangeDisturbanceStore from '@stores/ChangeDisturbanceStore';
import ProblemDisturbanceStore from '@stores/ProblemDisturbanceStore';
import IncidentDisturbanceStore from '@stores/IncidentDisturbanceStore';
import DisturbanceLocationModalStore from '@stores/DisturbanceLocationModalStore';
import MenuStore from '@stores/MenuStore';
import FilterStore from '@stores/FilterStore';
import TabStore from '@stores/TabStore';

const IS_NODE = isNode;

export class RootStore {
  public initialState: InitialState;
  public isNode: boolean;
  public router: RouterStore;
  public routing: RouterStore;
  public routeStore: RouteStore;
  public languageStore: LanguageStore;
  public ssoStore: SsoStore;
  public translateStore: TranslateStore;
  public menuStore: MenuStore;
  public cookieConsentStore: CookieConsentStore;
  public filterStore: FilterStore;
  public tabStore: TabStore;
  public disturbanceMapStore: DisturbanceMapStore;
  public disturbanceModalStore: DisturbanceModalStore;
  public changeDisturbanceStore: ChangeDisturbanceStore;
  public incidentDisturbanceStore: IncidentDisturbanceStore;
  public problemDisturbanceStore: ProblemDisturbanceStore;
  public disturbanceLocationModalStore: DisturbanceLocationModalStore;

  constructor(routing: RouterStore, initialState: InitialState) {
    this.isNode = IS_NODE;
    this.initialState = initialState;
    this.routing = routing;
    this.routeStore = new RouteStore(this);
    this.languageStore = new LanguageStore(this);
    this.ssoStore = new SsoStore(this);
    this.translateStore = new TranslateStore(this);
    this.menuStore = new MenuStore(this);
    this.cookieConsentStore = new CookieConsentStore(initialState.cookieConsents);
    this.tabStore = new TabStore(this);
    this.filterStore = new FilterStore(this);
    this.disturbanceMapStore = new DisturbanceMapStore(this);
    this.disturbanceLocationModalStore = new DisturbanceLocationModalStore(this);
    this.disturbanceModalStore = new DisturbanceModalStore(this);
    this.changeDisturbanceStore = new ChangeDisturbanceStore(this);
    this.incidentDisturbanceStore = new IncidentDisturbanceStore(this);
    this.problemDisturbanceStore = new ProblemDisturbanceStore(this);
  }

  public init() {
    // this.spinnerStore.show(FULL_PAGE);
    // Promise.all([this.translateStore.init()]).then(() => console.log('c'));
  }
}

export default RootStore;
